import { useEffect, useRef } from "react";

const ProvenExpertBadge = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Load ProvenExpert CSS once
    const existingLink = document.querySelector(
      'link[href*="provenexpert.com/css/widget_landing"]'
    );
    if (!existingLink) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = "https://www.provenexpert.com/css/widget_landing.css";
      link.media = "screen,print";
      document.head.appendChild(link);
    }

    // Remove any previous global pewl element the script may have targeted
    // and re-inject the script each time so it re-initializes on the current #pewl
    const oldScripts = document.querySelectorAll(
      'script[src*="provenexpert.com/widget/landing_renteplusimmobilie"]'
    );
    oldScripts.forEach((s) => s.remove());

    const script = document.createElement("script");
    script.src =
      "https://www.provenexpert.com/widget/landing_renteplusimmobilie-de.js?feedback=1&avatar=1&competence=1&language=de-de&style=white&t=" +
      Date.now();
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <section className="py-12 md:py-16">
      <div className="container-comfortable">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-primary text-center mb-8">
            Das sagen unsere Kunden
          </h2>
          <div id="pewl" ref={containerRef}></div>
        </div>
      </div>
    </section>
  );
};

export default ProvenExpertBadge;
